<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span>Update Lead Details</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="leadDetailsForm" (submit)="saveLeadDetails()">
                <div class="card-body">
                    <div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
                    <div class="row" *ngIf="dataLoaded">
                        <div class="container-fluid">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Name*</label>
                                            <input class="form-control" formControlName="lead_name"
                                                placeholder="Lead Name" />
                                            <div *ngIf="submitted && f.lead_name.errors" class="invalid-feedback">
                                                <div *ngIf="f.lead_name.errors.required">Lead Name is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Mobile</label>
                                            <input class="form-control" formControlName="lead_mobile" readonly=""
                                                placeholder="Lead Mobile" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead City</label>
                                            <input type="text" placeholder="City" formControlName="lead_city"
                                                readonly="" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Circle*</label>
                                            <mat-select placeholder="Select Circle" formControlName="circle">
                                                <mat-option>Select Circle</mat-option>
                                                <mat-option [value]="circle.id" *ngFor="let circle of circles">
                                                    {{circle.name}}</mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.circle.errors" class="invalid-feedback">
                                                <div *ngIf="f.circle.errors.required">Circle is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Owner*</label>
                                            <mat-select placeholder="Select Lead Owner" formControlName="lead_owner">
                                                <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}
                                                </mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.lead_owner.errors" class="invalid-feedback">
                                                <div *ngIf="f.lead_owner.errors.required">Lead Owner is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Treatment*</label>
                                            <mat-select placeholder="Select Treatment" formControlName="treatment">
                                                <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">
                                                    {{treatment.name}}</mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.treatment.errors" class="invalid-feedback">
                                                <div *ngIf="f.treatment.errors.required">Treatment is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Age</label>
                                            <input class="form-control" formControlName="age" placeholder="Age" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                                <label>Gender</label>
                                                <mat-select  placeholder="Gender" formControlName="gender">
                                                    <mat-option value="Male">Male</mat-option>
                                                    <mat-option value="Female">Female</mat-option>
                                                </mat-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Status*</label>
                                            <mat-select placeholder="Select Lead Status" formControlName="lead_status">
                                                <mat-option [value]="lead_status.id"
                                                    *ngFor="let lead_status of leadStatus">
                                                    {{lead_status.name}}</mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.lead_status.errors" class="invalid-feedback">
                                                <div *ngIf="f.lead_status.errors.required">Status is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Payment Mode*</label>
                                            <mat-select formControlName="payment_mode"
                                                placeholder="Select Payment Mode">
                                                <mat-option>Select</mat-option>
                                                <mat-option value="Cash">Cash</mat-option>
                                                <mat-option value="Cashless">Cashless</mat-option>
                                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                                <mat-option value="EMI">EMI</mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.payment_mode.errors" class="invalid-feedback">
                                                <div *ngIf="f.payment_mode.errors.required">Payment Mode is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Follow Up Date</label>
                                            <mat-form-field class="example-full-width" appearance="fill">
                                                <mat-label>Choose a date</mat-label>
                                                <input matInput formControlName="followup_date"
                                                    [matDatepicker]="picker1">
                                                <mat-datepicker-toggle matSuffix [for]="picker1">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                   <!--  <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Source</label>
                                            <input class="form-control" formControlName="lead_source" readonly=""
                                                placeholder="Lead Mobile" />
                                        </div>
                                    </div> -->
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Keywords</label>
                                            <input class="form-control" formControlName="keywords" readonly=""
                                                placeholder="Keywords" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Form Lead Source</label>
                                            <input class="form-control" formControlName="form_lead_source" readonly=""
                                                placeholder="Form Lead Source" />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Description*</label>
                                            <textarea class="form-control" formControlName="description"></textarea>
                                        </div>
                                        <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                            <div *ngIf="f.description.errors.required">Description is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')">
                                        <div class="form-group">
                                            <label>Feedback Description</label>
                                            <textarea class="form-control" formControlName="feedback_description"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Update</span>
                    </button>
                </div>
            </form>

        </div>

    </div>
</div>